
/**
 * Map a value from one range 'a' to different range 'b'
 *
 * @param sourceMin - The minimum value of the source range
 * @param sourceMax - The maximum value of the source range
 * @param targetMin - The minimum value of the target range
 * @param targetMax - The maximum value of the target range
 * @param num - The number to map
 * @returns The mapped value
 */
function mapRange(sourceMin, sourceMax, targetMin, targetMax, num) {
  return (num - sourceMin) * (targetMax - targetMin) / (sourceMax - sourceMin) + targetMin;
}
/**
 * Limit a number between 2 values, inclusive
 *
 * @param min - The minimum value
 * @param max - The maximum value
 * @param num - The number to clamp
 * @returns The clamped number
 */
function clamp(min, max, num) {
  return Math.min(max, Math.max(min, num));
}


document.addEventListener("DOMContentLoaded", function(event) {
  document.addEventListener('mousemove', function(event) {
    const mouseX = event.clientX;
    const mouseY = event.clientY;
    //const element = document.getElementById('yourElementId');
    const elements = document.getElementsByClassName('tw-sparkle');

    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        const rect = entry.boundingClientRect;
        
        var centerX = rect.left + rect.width / 2;
        var isXStartFarthest = centerX >= windowWidth / 2;
        const xDuration = (isXStartFarthest ? centerX : windowWidth - centerX) * 2;
        const x0 = isXStartFarthest ? 0 : centerX - xDuration / 2;
        var normalX = (mouseX - x0) / xDuration;
        var actualx = +clamp(0, 1, normalX).toPrecision(4);

        const rotate = mapRange(0, 1, -angle, angle, actualx) * invert;
        entry.target.style.transform = `translateX(${translateX}px) translateY(${translateY}px) rotate(calc(${rotate}deg + var(--comp-rotate-z, 0deg)))`;
      }
    
      observer.disconnect();
    });

    const windowWidth = window.innerWidth;
    
    const normalizedX = mouseX / window.innerWidth;
    const normalizedY = mouseY / window.innerHeight;

    const x = +clamp(0, 1, normalizedX).toPrecision(4);
    const y = +clamp(0, 1, normalizedY).toPrecision(4);

    var translateX = 0;
    var translateY = 0;
    const angle = 85;
    const invert = 1;
    const translateDist = 10;
    
    //translateX = mapRange(0, 1, -translateDist, translateDist, normalizedX) * invert;
    translateY = mapRange(0, 1, -translateDist, translateDist, normalizedY) * invert;

    for(const element of elements) {
      observer.observe(element);
    }
    
    /*
    for(let element of elements)
    {
      var rect = element.getBoundingClientRect();
      var centerX = rect.left + rect.width / 2;
      //const centerY = rect.top + rect.height / 2;

      var isXStartFarthest = centerX >= windowWidth / 2;
      const xDuration = (isXStartFarthest ? centerX : windowWidth - centerX) * 2;
      const x0 = isXStartFarthest ? 0 : centerX - xDuration / 2;
      var normalX = (mouseX - x0) / xDuration;
      var actualx = +clamp(0, 1, normalX).toPrecision(4);

      //var xdiff = mouseX - centerX;

      //var xdiffnormalized = mapRange(-centerX, windowWidth - centerX, 0, 1, xdiff);
      
      //const radians = Math.atan2(mouseX - centerX, mouseY - centerY);
      //const degrees = radians * (180 / Math.PI) * -1 + 90;
      
      const rotate = mapRange(0, 1, -angle, angle, actualx) * invert;
      
      //elements[0].style.transform = `rotate(${degrees}deg)`;
      element.style.transform = `translateX(${translateX}px) translateY(${translateY}px) rotate(calc(${rotate}deg + var(--comp-rotate-z, 0deg)))`;
        
    }
    */
    

  });
});



/*
class AiryMouseAnimation extends CustomMouse {
  progress(_ref) {
    let {
      x: progressX,
      y: progressY
    } = _ref;
    let translateX = 0;
    let translateY = 0;
    const {
      distance,
      invert,
      angle,
      axis
    } = this.options;
    if (axis !== 'vertical') {
      translateX = mapRange(0, 1, -distance.value, distance.value, progressX) * invert;
    }
    if (axis !== 'horizontal') {
      translateY = mapRange(0, 1, -distance.value, distance.value, progressY) * invert;
    }

    // if progress  === 0, rotate === angle, if progress === 0.5, rotate === 0, if progress === 1, rotate === angle
    const rotate = mapRange(0, 1, -angle, angle, progressX) * invert;
    const units = getCssUnits(distance.type);
    this.target.style.transform = translateX({translateX}{units}) translateY({translateY}{units}) rotate(calc({rotate}deg + var(--comp-rotate-z, 0deg)));
  }
  cancel() {
    this.target.style.transform = '';
    this.target.style.transition = '';
  }
}
export default function create(options) {
  const {
    transitionDuration,
    transitionEasing
  } = options;
  const {
    power,
    inverted = false,
    distance = {
      value: 200,
      type: 'px'
    },
    angle = 30,
    axis = 'both'
  } = options.namedEffect;
  const invert = inverted ? -1 : 1;
  const animationOptions = {
    transition: transitionDuration ? transform {transitionDuration}ms {getMouseTransitionEasing(power ? paramsMap[power].easing : transitionEasing)} : '',
    invert,
    distance,
    angle: power ? paramsMap[power].angle : angle,
    axis
  };
  return target => new AiryMouseAnimation(target, animationOptions);
}
*/